import { post, get } from '../../../components/hooks/apiFetch';

export const useSummarizeResumeApi = () => {
    const submitSummarizeResumeRequest = async (filesWithFormats, comment = '', startTime = '') => {
        comment ??= '';
        const formData = new FormData();
        filesWithFormats.forEach((item, index) => {
            formData.append(`Files[${index}].File`, item.file, item.file.name);
            formData.append(`Files[${index}].OutputFormat`, item.outputFormat);
            if (item.templateName && item.templateName.trim() !== '') {
                formData.append(`Files[${index}].TemplateName`, item.templateName);
            }
        });

        formData.append("Options.Comment", comment.trim());
        formData.append("Options.StartTime", startTime);

        const result = await post("/api/summarizeresume", formData);

        return {
            id: result.id,
            identifier: result.identifier
        };
    };

    const cancelSummarizeResumeTask = async (inputIdentifier) => {
        await get(`/api/summarizeresume/cancel/${encodeURIComponent(inputIdentifier)}`);
        return true;
    };

    return { submitSummarizeResumeRequest, cancelSummarizeResumeTask };
};